// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4ni5j","title":"styles_title__fxx4d","subtitle":"styles_subtitle__xJ48O","addButton":"styles_addButton__3Ay0q"};